import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

export type FastPracovnikSelect = {
	OsobniCis?: string;
	PracovnikOzn?: string;
	ProvozovnaId?: number;
	PracovnikId?: number;
	PracovnikText?: string;
	ProvozovnaIdText?: number;
};

class PracovnikProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	getPracovnikByPersonCard(personcardId: number) {
		return this.fetch(`${this.apiPath}GetPracovnikByPersonCard`, { personcardId });
	}

	validateLocationCode(code: string, id: number, locationId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/ValidateLocationCode?Code=${code}&Id=${id}&LocationId=${locationId}`);
	}
}

export const apiProvider = new PracovnikProvider();
